import { createFileRoute } from '@tanstack/react-router';
import { GeneralCrudPage } from '@/features/admin/GeneralCrud';

export const Route = createFileRoute('/_app/general-crud')({
  component: GeneralCrudPage,
  validateSearch: (s: Record<string, unknown>) => ({
    entity: typeof s.entity === 'string' ? s.entity : undefined,
  }),
});
